import { useEffect } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { ContentLoader } from '@frontend/design-system';
import { useAuth } from '../../providers/auth.provider';
import { createFileRoute } from '../../utils/route-factory';

function LoginCallback() {
  const { handleAuthCallback } = useAuth();

  useEffect(() => {
    handleAuthCallback();
  }, []);
  return (
    <main
      css={css`
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: ${theme.spacing(1)};
        width: 100vw;
        height: 100vh;
      `}
    >
      <ContentLoader message={'Logging in. . .'} show />
    </main>
  );
}

export const Route = createFileRoute({ path: '/sign-in/callback', component: LoginCallback, type: 'public' });
